// src/hooks/useUserProfile.ts
import { useEffect, useContext } from "react";
import { useDispatch } from "react-redux";
import { AuthContext } from "../AuthContent";
import { authenticateToken } from "../../actions/app.action";


export const useUserProfile = () => {
  const { keycloak } = useContext(AuthContext);
  const dispatch = useDispatch();

  useEffect(() => {
    if (keycloak) {
      (keycloak.loadUserProfile() as any).then((profile: any) => {
        if (profile) {
          dispatch(authenticateToken(profile.firstName, profile.lastName) as any);
        }
      });
    }
  }, [keycloak, dispatch]);
};
